module.exports = __webpack_public_path__ + "static/img/404.0c1390e7.gif";